import { useCallback } from 'react';

function usePasteValueTransform(param) {
    var transform = param.transform;
    var onPaste = useCallback(function(event) {
        var _event_clipboardData;
        if (transform == null) return;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        var pastedValue = (_event_clipboardData = event.clipboardData) === null || _event_clipboardData === void 0 ? void 0 : _event_clipboardData.getData("text/plain"); // conditional because it doesn't exist in IE
        if (pastedValue == null) return;
        event.preventDefault();
        var transformedValue = transform(pastedValue);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        nativeInputValueSetter.call(event.target, transformedValue);
        var synthesizedChangeEvent = new Event("input", {
            bubbles: true
        });
        event.target.dispatchEvent(synthesizedChangeEvent);
    }, [
        transform
    ]);
    return {
        onPaste: onPaste
    };
}

export { usePasteValueTransform };
